export const reduceReadOrganizationRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingOrganization: true },
  };
};

export const reduceReadOrganizationSuccess = (
  state,
  { payload: { organizations } },
) => {
  if (!Array.isArray(organizations) || !organizations.length)
    return { ...state, ui: { ...state.ui, isFetchingOrganization: false } };

  const { allIDs = [], byId = {} } = state?.base || {};

  const newAllIDs = [...allIDs];
  const newById = { ...byId };

  for (let i = 0, l = organizations.length; i < l; i += 1) {
    const organization = organizations[i];
    const { id } = organization;

    newAllIDs.push(id);
    newById[id] = { ...organization };
  }

  return {
    ...state,
    base: {
      ...state.base,
      allIDs: [...new Set([...newAllIDs])].sort(),
      byId: newById,
    },
    ui: { ...state.ui, isFetchingOrganization: false },
  };
};

export const reduceReadOrganizationFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingOrganization: false },
  };
};
